export default __webpack_public_path__ + "static/media/excellent-pizzas.f4aefefb.svg";